import { TMenuRow } from "../../gui/Menu/Menu";
import DateRangeFilter from "../widgets/DateRangeFilter";
import PortUtils from "../../portlibs/PortUtils";
import Toolbar from "../widgets/Toolbar";

export default function HomeToolbar(props:{onExport:Function}){
    const MenuOptions : TMenuRow<string>[] = [
        {id:"add",text:"New Equity",url:{hash:PortUtils.createHash("", "add")}},
        {id:"export",text:"Export",onClick:() => props.onExport()}
    ]
    return <Toolbar options={MenuOptions}><DateRangeFilter/></Toolbar>
}